import { useCallback, useState, type ReactNode } from "react";
import type { AddNotification, Notification } from "@inloco/shared";
import { nanoid } from "nanoid";
import NotificationContext from "../contexts/NotificationContext";
import NotificationComp from "../components/ui/Notification";

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
    const [notifications, setNotifications] = useState<Notification[]>([]);

    const removeNotification = useCallback((id: string) => {
        setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, []);

    const addNotification = useCallback(({ message, type = 'info', duration = 5000, closable = true }: AddNotification) => {
        const id = nanoid();
        const notification = { id, message, type, duration, closable };

        setNotifications((prev: Notification[]) => [...prev, notification]);

        // Auto-dismiss dopo duration (se non 0)
        if (duration > 0) {
            setTimeout(() => {
                removeNotification(id);
            }, duration);
        }
    }, [removeNotification]);

    return (
        <NotificationContext.Provider value={{ addNotification, removeNotification }}>
            {children}
            {notifications.length > 0 && (
                <div className="toast toast-start toast-bottom z-999999 pointer-events-none">
                    <div className="stack pointer-events-auto">
                        {notifications.map((n) => (
                            <NotificationComp
                                key={n.id}
                                notification={n}
                                onDismiss={removeNotification}
                            />))}
                    </div>
                </div>
            )}
        </NotificationContext.Provider>
    );
};